/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createIsPrime } from '../../factoriesAny.js';
export var isPrimeDependencies = {
  typedDependencies: typedDependencies,
  createIsPrime: createIsPrime
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesIsPrime.generated.js
// module id = 1432
// module chunks = 0